import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: false,
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
  @Input() pagination: any;
  @Input() pagingOptions: any;
  @Output() changePage: EventEmitter<number> = new EventEmitter<number>();
  constructor(
  ) { }

  ngOnInit(): void {

  }

  listPrevious() {
    this.pagingOptions.page = this.pagination.page > 1 ? this.pagination.page - 1 : 1;
    this.changePage.emit(this.pagingOptions.page);
  }
  listNext() {
    this.pagingOptions.page = this.pagination.page < this.pagination.totalPage ? this.pagination.page + 1 : this.pagination.totalPage;
    this.changePage.emit(this.pagingOptions.page);
  }
  listPage(page: any) {
    this.pagingOptions.page = page;
    this.changePage.emit(page);
  }

  goPage(page: any) {
    this.listPage(page.value);
  }

  firstPage() {
    this.listPage(1);
  }

  finalPage() {
    this.listPage(this.pagination.totalPage);
  }


}


